import useExperimentCheckFunction, { useExperimentControlCheckFunction, useExperimentGroupCheckFunction } from './useExperimentCheckFunction';
export default function useExperiment(experimentName, callHook = true, sendCheck = true) {
  return useExperimentCheckFunction(callHook, sendCheck)(experimentName);
}
export function useExperimentControl(experimentNames, callHook = true, sendCheck = true) {
  return useExperimentControlCheckFunction(callHook, sendCheck)(experimentNames);
}
export function useExperimentGroup(experimentName) {
  return useExperimentGroupCheckFunction()(experimentName);
}
//# sourceMappingURL=useExperiment.js.map